import { render, staticRenderFns } from "./DialogMessageTemplateExternalAutocompleteSingle.vue?vue&type=template&id=0458f6c0"
import script from "./DialogMessageTemplateExternalAutocompleteSingle.vue?vue&type=script&lang=js"
export * from "./DialogMessageTemplateExternalAutocompleteSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports